/*eslint-disable*/
import React, { useState, useEffect, use } from "react";
import { useLocation } from "react-router-dom";
import authService from "services/auth.service";
import tokenService from "services/token.service";
import userService from "services/user.service";


export default function Navbar(props) {
  const [currentUser, setCurrentUser] = useState(authService.getCurrentUser());
  const [publicUser, setPublicUser] = useState(null);
  const [navbarOpen, setNavbarOpen] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/" || location.pathname.startsWith('/subasta/ejemplo')) {
      setShowButton(true);
    }
  }, [location]);

  useEffect(() => {
    userService.checkBackend()
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      }
      );
  }, []);

  useEffect(() => {
    if (currentUser !== null) {
      userService.getUser()
        .then((response) => {
          if (response === false) {
            //tokenService.removeUser();
            setCurrentUser(null);
            return;
          } else {
            setPublicUser(response.data.publicUser);
          }
        })
        .catch((error) => {
          console.log(error);
          tokenService.removeUser();
          setCurrentUser(null);
          return;
        })
    }
  }, [currentUser]);

  return (
    <>
      <nav className="top-0 absolute z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg">
        <div className="container px-4 mx-auto flex flex-col md:flex-row items-center justify-between">
          <div className="w-full relative flex justify-between items-center">
            <a
              className="text-sky-900 text-2xl font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap"
              href="/"
            >
              SubastasBOEPro.com
            </a>

            <button
              className="block md:hidden cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className="fas fa-bars"></i>
            </button>
          </div>
          <div
            className={
              "md:flex flex-grow self-end md:self-center md:items-center bg-blueGray-100 md:bg-transparent p-4 lg:bg-opacity-0 lg:shadow-none w-full" +
              (navbarOpen ? " flex" : " hidden")
            }
            id="example-navbar-warning"
          >
            <ul className="flex flex-col md:flex-row items-center gap-4 md:gap-8list-none lg:ml-auto w-full">
              {publicUser && (
                <li className="flex items-end justify-end w-full">
                  <div
                    className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-1 px-3 rounded-full"
                  >
                    <i className={`fas fa-coins mr-2`}></i>
                    {publicUser.balance}
                  </div>
                </li>
              )}
              {showButton && (
                <li className="flex items-end justify-end w-full">
                  <a href="/asistente">
                    <button
                      type="button"
                      className="block text-white bg-gradient-to-br from-pink-500 to-orange-400 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-pink-200 dark:focus:ring-orange-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                    >
                      ANALIZA TU SUBASTA AHORA
                      <i className="fas fa-arrow-right ml-2"></i>
                    </button>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
